import styled from "styled-components";

export const ContactSection = styled.section`
  width: 100%;
  height: 450px;
  position: relative;
  background: #1D1D1D;
  
  @media (max-width: 1700px) {
    height: 450px;
  }
  
  @media (max-width: 1440px) {
    height: 450px;
  }
`;

export const ContactTitle = styled.div`
  left: 240px;
  top: 97px;
  position: absolute;
  color: white;
  font-size: 48px;
  line-height: 70px;
  word-wrap: break-word;
  
  @media (max-width: 1920px) {
    left: calc(240px * 100vw / 1920);
    top: calc(97px * 100vw / 1920);
    font-size: calc(48px * 100vw / 1920);
    line-height: calc(70px * 100vw / 1920);
  }
  
  @media (max-width: 1700px) {
    left: 160px;
    font-size: 42px;
    line-height: 60px;
  }
  
  @media (max-width: 1440px) {
    left: 80px;
    top: 97px;
    font-size: 36px;
    line-height: 52px;
  }
`;

export const ContactButtons = styled.div`
  left: 240px;
  top: 287px;
  position: absolute;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 14px;
  
  @media (max-width: 1920px) {
    left: calc(240px * 100vw / 1920);
    top: calc(287px * 100vw / 1920);
    gap: calc(14px * 100vw / 1920);
  }
  
  @media (max-width: 1700px) {
    left: 160px;
    gap: 14px;
  }
  
  @media (max-width: 1440px) {
    left: 80px;
    top: 287px;
    gap: 14px;
  }
`;

export const ContactButton = styled.div`
  width: 160px;
  height: 60px;
  padding: 16px 30px;
  background: #FF4F00;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  box-sizing: border-box;
  transition: background-color 0.3s ease;
  
  &:hover {
    background: #E64600;
  }
  
  > div {
    color: white;
    font-size: 16px;
    font-family: 'Pretendard', sans-serif;
    font-weight: 700;
    line-height: 28px;
    word-wrap: break-word;
    text-align: center;
    white-space: nowrap;
  }
  
  @media (max-width: 1920px) {
    width: calc(160px * 100vw / 1920);
    height: calc(60px * 100vw / 1920);
    padding: calc(16px * 100vw / 1920) calc(30px * 100vw / 1920);
  }
  
  @media (max-width: 1700px) {
    width: calc(160px * 100vw / 1920);
    height: calc(60px * 100vw / 1920);
    padding: calc(16px * 100vw / 1920) calc(30px * 100vw / 1920);
  }
  
  @media (max-width: 1440px) {
    width: 160px;
    height: 60px;
    padding: 16px 30px;
  }
`;

export const DownloadButton = styled.div`
  width: 200px;
  height: 60px;
  padding: 16px 20px;
  background: white;
  border-radius: 50px;
  border: 1px #DCDCDC solid;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  box-sizing: border-box;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: #FF4F00;
    
    > div {
      color: #FF4F00;
    }
  }
  
  > div {
    color: #1D1D1D;
    font-size: 16px;
    font-family: 'Pretendard', sans-serif;
    font-weight: 500;
    line-height: 28px;
    word-wrap: break-word;
    text-align: center;
    white-space: nowrap;
    transition: color 0.3s ease;
  }
  
  @media (max-width: 1920px) {
    width: calc(200px * 100vw / 1920);
    height: calc(60px * 100vw / 1920);
    padding: calc(16px * 100vw / 1920) calc(20px * 100vw / 1920);
  }
  
  @media (max-width: 1700px) {
    width: calc(200px * 100vw / 1920);
    height: calc(60px * 100vw / 1920);
    padding: calc(16px * 100vw / 1920) calc(20px * 100vw / 1920);
  }
  
  @media (max-width: 1440px) {
    width: 200px;
    height: 60px;
    padding: 16px 20px;
  }
`;

export const ContactGraphic = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 1010px;
  height: 450px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transition: transform 0.5s ease;
    
    &:hover {
      transform: scale(1.1);
    }
  }
  
  @media (max-width: 1920px) {
    width: calc(1010px * 100vw / 1920);
    height: calc(450px * 100vw / 1920);
  }
  
  @media (max-width: 1700px) {
    width: calc(1010px * 100vw / 1920);
    height: calc(450px * 100vw / 1920);
  }
  
  @media (max-width: 1440px) {
    width: 700px;
    height: 450px;
  }
`;

export const FooterContainer = styled.footer`
  width: 100%;
  height: 305px;
  background: #1D1D1D;
  color: white;
  position: relative;
  z-index: 10;
  box-sizing: border-box;
  padding: 50px 240px 60px 240px;
  border-top: 1px #4D4D4D solid;
  display: flex;
  justify-content: space-between;

  
  @media (max-width: 1700px) {
    padding: 50px 160px 40px;
  }

  @media (max-width: 1440px) {
    padding: 50px 80px 40px;
  }

  @media (max-width: 768px) {
    height: 221px;
    padding: 30px 20px 27px;
    display: block;
  }
`;

export const FooterLeftSection = styled.div`
  position: relative;
  height: 100%;
`;

export const FooterRightSection = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const FooterContent = styled.div`
  height: 160px;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 21px;
  display: inline-flex;

  @media (max-width: 768px) {
    position: relative;
    height: auto;
    width: 100%;
    gap: 15px;
  }
`;

export const FooterLogo = styled.div`
  align-self: stretch;
  color: white;
  font-size: 32px;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  line-height: 40px;
  word-wrap: break-word;
  position: relative;

  @media (max-width: 1700px) {
    font-size: 30px;
    line-height: 38px;
  }

  @media (max-width: 1440px) {
    font-size: 28px;
    line-height: 36px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 28px;
    letter-spacing: -0.01em;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const FooterInfo = styled.div`
  align-self: stretch;
  height: 134px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: flex;

  @media (max-width: 1700px) {
    height: 134px;
    gap: 16px;
  }

  @media (max-width: 1440px) {
    height: 134px;
    gap: 16px;
  }

  @media (max-width: 768px) {
    height: auto;
    gap: 10px;
  }
`;

export const FooterAddress = styled.div`
  align-self: stretch;
  color: white;
  font-size: 16px;
  font-family: "Pretendard", sans-serif;
  font-weight: 500;
  line-height: 28px;
  word-wrap: break-word;

  @media (max-width: 1700px) {
    font-size: 15px;
    line-height: 26px;
  }

  @media (max-width: 1440px) {
    font-size: 14px;
    line-height: 24px;
  }

  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 12px;
    letter-spacing: -0.01em;
    font-weight: 400;
  }
`;

export const FooterContact = styled.div`
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: flex;

  > div:last-child {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  @media (max-width: 1700px) {
    gap: 8px;
    > div:last-child {
      gap: 4px;
    }
  }

  @media (max-width: 1440px) {
    gap: 8px;
    > div:last-child {
      gap: 4px;
    }
  }

  @media (max-width: 768px) {
    gap: 8px;
    align-items: center;
    
    > div:last-child {
      gap: 6px !important;
    }
  }
`;

export const ContactItem = styled.div`
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: inline-flex;

  @media (max-width: 1700px) {
    gap: 8px;
  }

  @media (max-width: 1440px) {
    gap: 8px;
  }

  @media (max-width: 768px) {
    gap: 0;
  }
`;

export const ContactLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
  
  @media (max-width: 768px) {
    gap: 6px;
  }
`;

export const ContactLabel = styled.div`
  color: #DCDCDC;
  font-size: 16px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  line-height: 28px;
  word-wrap: break-word;
  min-width: 22px;
  display: inline-block;
  padding: 0;
  margin: 0;

  @media (max-width: 1700px) {
    font-size: 15px;
    line-height: 28px;
  }

  @media (max-width: 1440px) {
    font-size: 14px;
    line-height: 28px;
  }

  @media (max-width: 768px) {
    font-size: 10px;
    letter-spacing: -0.01em;
    font-weight: 400;
    line-height: 1;
    min-width: 15px;
  }
`;

export const EmailLabel = styled(ContactLabel)`
  width: 22px;

  @media (max-width: 1700px) {
    width: 21px;
  }

  @media (max-width: 1440px) {
    width: 20px;
  }
  
  @media (max-width: 768px) {
    width: 15px;
  }
`;

export const ContactValue = styled.div`
  color: white;
  font-size: 16px;
  font-family: "Pretendard", sans-serif;
  font-weight: 500;
  line-height: 28px;
  word-wrap: break-word;
  padding: 0;
  margin: 0;

  @media (max-width: 1700px) {
    font-size: 15px;
    line-height: 28px;
  }

  @media (max-width: 1440px) {
    font-size: 14px;
    line-height: 28px;
  }

  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 1;
    letter-spacing: -0.01em;
    font-weight: 400;
  }
`;

export const SocialMediaContainer = styled.div`
  cursor: pointer;
  display: flex;
  gap: 30px;

  img {
    width: 36px;
    height: 36px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileSocialContainer = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: inline-flex;
    gap: 16px;
    margin-left: auto;
    align-items: center;
    
    img {
      width: 24px;
      height: 24px;
    }
  }
`;

export const PCCopyright = styled.div`
  color: #999999;
  font-size: 16px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  line-height: 28px;
  word-wrap: break-word;
  white-space: nowrap;

  @media (max-width: 1700px) {
    font-size: 15px;
    line-height: 26px;
  }

  @media (max-width: 1440px) {
    font-size: 14px;
    line-height: 24px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileCopyright = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
    color: #999999;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: -0.01em;
    font-weight: 400;
    margin-top: 25px;
    align-self: flex-start;
    text-align: left;
  }
`;

export const FooterInfoItem = styled.div`
  color: #5C5C5C;
  font-size: 14px;
  font-family: 'Pretendard', sans-serif;
  line-height: 1.5;
  
  &:not(:last-child)::after {
    content: "|";
    margin-left: 20px;
    color: #DCDCDC;
    margin-right: 20px;
  }
  
  @media (max-width: 1920px) {
    font-size: calc(14px * 100vw / 1920);
  }
  
  @media (max-width: 1700px) {
    font-size: 14px;
  }
  
  @media (max-width: 1440px) {
    font-size: 13px;
  }
`;

export const FooterCopyright = styled.div`
  color: #999999;
  font-size: 14px;
  font-family: 'Pretendard', sans-serif;
  margin-top: 10px;
  
  @media (max-width: 1920px) {
    font-size: calc(14px * 100vw / 1920);
    margin-top: calc(10px * 100vw / 1920);
  }
  
  @media (max-width: 1700px) {
    font-size: 14px;
    margin-top: 10px;
  }
  
  @media (max-width: 1440px) {
    font-size: 13px;
    margin-top: 10px;
  }
`;
